<template lang="pug">
  .component.component-backoffice-card(v-if="item")
    .card
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="5")
          div(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
              card-action-buttons(:card="item")
          .field-value(slot="n1") {{item.name}}
            p {{item.id}} {{item.uid}}
          .field-value(slot="n2")
            driver(:type="'oneLook'", :item="item.driver")
          .field-value(slot="n3") {{item.chip_id}}
          .field-value(slot="n4") {{item.enabled}}
          .field-value(slot="n5") {{item.id}} {{item.uid}}
</template>
<script type="text/babel">
  import Card4 from 'components/structure/Card4'
  import Driver from 'components/backoffice/Driver'
  import Dropdown from "components/structure/foundation/Dropdown";
  import CardActionButtons from "components/structure/ui/actions/CardActionButtons";
  import CardN from "../structure/CardN"

  export default {
    name: "",
    components: {
      CardN,
      CardActionButtons,
      Dropdown,
      Card4,
      Driver
    },
    data() {
      return {}
    },
    created() {
    },
    methods: {},
    computed: {},
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>


// WEBPACK FOOTER //
// Card.vue?1b24bcea